module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_3016.c8b2a4cc.png";